import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, HelpCircle, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4" 
      style={{ backgroundColor: 'var(--bg-primary)' }}>
      <Card className="premium-card max-w-2xl w-full p-8 md:p-12 text-center">
        {/* Cancel Icon */}
        <div className="mb-6">
          <div className="w-20 h-20 mx-auto rounded-full flex items-center justify-center"
            style={{ backgroundColor: 'rgba(239, 68, 68, 0.1)' }}>
            <XCircle className="w-12 h-12" style={{ color: '#ef4444' }} />
          </div>
        </div>

        {/* Cancel Message */}
        <h1 className="heading-lg mb-4">Payment Cancelled</h1>
        <p className="text-lg mb-8" style={{ color: 'var(--text-grey)' }}>
          Your payment was not completed. No charges have been made to your account.
        </p>

        {/* Help Section */}
        <Card className="bg-[var(--bg-light)] p-6 mb-8 text-left">
          <h3 className="font-semibold mb-4 flex items-center gap-2">
            <HelpCircle className="w-5 h-5" style={{ color: 'var(--accent-teal)' }} />
            Need Help?
          </h3>
          <div className="space-y-3 text-sm" style={{ color: 'var(--text-grey)' }}>
            <p>If you experienced any issues during checkout:</p>
            <ul className="list-disc list-inside space-y-2 ml-2">
              <li>Make sure your card details are correct</li>
              <li>Check that your card has sufficient funds</li>
              <li>Try a different payment method</li>
              <li>Contact your bank if the issue persists</li>
            </ul>
          </div>
        </Card>

        {/* Contact Support */}
        <div className="mb-8 p-4 rounded-lg" style={{ backgroundColor: 'rgba(20, 184, 166, 0.05)' }}>
          <div className="flex items-center justify-center gap-2 mb-2">
            <Mail className="w-5 h-5" style={{ color: 'var(--accent-teal)' }} />
            <p className="font-semibold">Still Need Assistance?</p>
          </div>
          <p className="text-sm" style={{ color: 'var(--text-grey)' }}>
            Our team is here to help! Email us at{' '}
            <a href="mailto:info@winhousetutors.com" 
              className="font-medium hover:underline" 
              style={{ color: 'var(--accent-teal)' }}>
              info@winhousetutors.com
            </a>
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={() => navigate('/pay')}
            className="premium-button flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Try Again
          </Button>
          <Button
            onClick={() => navigate('/')}
            className="premium-button-secondary"
          >
            Back to Home
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default PaymentCancelPage;
